export const LAYOUT_BODY_CLASSNAME = 'payment-card-list-container';
